import KModelProxy from "./KModelProxy";
import KTextField from "./KTextField";
import { VTextField } from "vuetify/lib";
import { ValidationProvider } from "vee-validate";
import { createMask } from "imask/esm";

export default KTextField.extend( {
	name: "KMaskedTextField",

	props: {
		maskOptions: {
			required: true,
			type: Object
		}
	},

	inheritAttrs: false,

	data: vm => ( {
		maskObj: createMask( vm.maskOptions )
	} ),

	computed: {
		propsToPass() {
			const props = {};

			Object.keys( this.$props ).forEach( prop => {
				if ( prop in KTextField.options.props ) {
					props[prop] = this.$props[prop];
				}
			} );

			return props;
		},

		unmaskedValue: {
			get() {
				return this.maskObj.unmaskedValue;
			},
			set( val ) {
				this.maskObj.unmaskedValue = val;

				this.$emit( "input", this.maskObj.unmaskedValue );
			}
		},

		maskedValue: {
			get() {
				return this.maskObj.value;
			},
			set( val ) {
				this.maskObj.value = val;
			}
		}
	},

	watch: {
		maskOptions( val ) {
			this.maskObj.updateOptions( val );
		},

		value: {
			handler( val ) {
				this.unmaskedValue = val ? String( val ) : "";
			},
			immediate: true
		}
	},

	render() {
		return <ValidationProvider
			bails={this.validationBails}
			debounce={this.validationDebounce}
			immediate={this.validationImmediate}
			mode={this.validationMode}
			name={this.validationName}
			rules={this.validationRules}
			scopedSlots={{
				default: props =>
					<KModelProxy vModel={this.unmaskedValue}>
						<VTextField
							attrs={{
								...this.propsToPass,
								errorMessages: props.errors
							}}
							maxLength={this.maxLength}
							on={{ ...this.$listeners }}
							scopedSlots={this.$scopedSlots}
							vModel={this.maskedValue}
						></VTextField>
					</KModelProxy>
			}}
			slim
			vid={this.validationId}
		></ValidationProvider>;
	}
} );
